import { render, staticRenderFns } from "./WineSensorAttributes.vue?vue&type=template&id=2e262502&scoped=true"
import script from "./WineSensorAttributes.vue?vue&type=script&lang=ts"
export * from "./WineSensorAttributes.vue?vue&type=script&lang=ts"
import style0 from "./WineSensorAttributes.vue?vue&type=style&index=0&id=2e262502&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e262502",
  null
  
)

export default component.exports